export default __webpack_public_path__ + "static/media/icon-explore-active.47bdf113.svg";